export function applyChatbotExtraData(chatbotInstance, extraData) {
  if (!chatbotInstance) {
    return;
  }
  chatbotInstance.cleanExtraData();
  chatbotInstance.setExtraData(extraData && typeof extraData === 'object' ? extraData : {});
}

export function getLivenessIdentityFromHref(href) {
  try {
    const url = new URL(href);
    return url.pathname.split('/').join('');
  } catch (e) {
    return '';
  }
}

export function buildLivenessChatbotExtraData({ identity, hasError, errorCode } = {}) {
  if (!identity) {
    return {};
  }

  const step_data = {
    identity,
    step: `face_liveness/${identity}`,
  };

  if (hasError) {
    step_data.status = 'ERROR';
    if (errorCode) {
      step_data.error_code = errorCode;
    }
  }

  return {
    resume: {
      type: 'face_liveness',
      extra: {},
    },
    step_data,
  };
}
